import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface CustomPage {
  id: string;
  title: string;
  slug: string;
}

/**
 * Published custom pages that are flagged to appear in the navigation bar.
 * Ordered by `sort_order` ascending, matching the original Navbar query.
 */
export function useNavCustomPages(orgId: string | undefined) {
  return useQuery({
    queryKey: ['nav-custom-pages', orgId],
    enabled: Boolean(orgId),
    queryFn: async (): Promise<CustomPage[]> => {
      const { data, error } = await supabase
        .from('custom_pages')
        .select('id, title, slug')
        .eq('organization_id', orgId!)
        .eq('is_published', true)
        .eq('show_in_nav', true)
        .order('sort_order');

      if (error) throw error;

      return data ?? [];
    },
  });
}
